import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-collage-publish-drawer',
  templateUrl: './collage-publish-drawer.component.html',
  styleUrls: ['./collage-publish-drawer.component.scss']
})
export class CollagePublishDrawerComponent implements OnInit {
  @Input() parentContainer: HTMLDivElement;
  @Input() screenshotData: any;

  isBottomMenuExpanded: boolean;


  constructor() { }

  ngOnInit(): void {
  }

  onClickOutside() {
    this.isBottomMenuExpanded = false;
  }

  onBottomMenuClick() {
    this.isBottomMenuExpanded = !this.isBottomMenuExpanded;
  }

  open() {
    this.isBottomMenuExpanded = true;
  }

  close() {
    this.isBottomMenuExpanded = false;
  }
}
